(function () {
  const SCROLL_THRESHOLD = 300;
  const TEASER_DURATION_MS = 10000;
  const CHATARMIN_BUBBLE_SIZE = ['de', 'nl'].includes(document.documentElement.lang)
    ? 60
    : 50;

  let wasWidgetVisible = false;
  let teaserHideTimeout = null;

  const getTeaser = () => {
    const wrapper = document.querySelector('.chatarmin-widget-wrapper');
    const teaser = wrapper?.querySelector('.teaser-message');
    if (!teaser) return null;

    const widgetId = teaser.id?.replace('teaserMessage-', '') || '';
    return { wrapper, teaser, widgetId };
  };

  const isTeaserDismissedByUser = (widgetId) =>
    sessionStorage.getItem(`plumelle-teaser-user-closed-${widgetId}`) === 'true';

  const isScrollTeaserShown = (widgetId) =>
    sessionStorage.getItem(`plumelle-scroll-teaser-shown-${widgetId}`) === 'true';

  const hideScrollTeaser = (teaser, widgetId) => {
    teaser.classList.remove('show');
    if (widgetId) {
      sessionStorage.setItem(`plumelle-scroll-teaser-shown-${widgetId}`, 'true');
    }
  };

  const bindTeaserClose = () => {
    const found = getTeaser();
    if (!found || found.teaser.dataset.plumelleBound) return;

    const { teaser, widgetId } = found;
    const closeBtn = teaser.querySelector('.teaser-close');
    if (!closeBtn) return;

    found.teaser.dataset.plumelleBound = 'true';
    closeBtn.addEventListener(
      'click',
      () => {
        clearTimeout(teaserHideTimeout);
        teaser.classList.remove('show');
        if (widgetId) {
          sessionStorage.setItem(`plumelle-teaser-user-closed-${widgetId}`, 'true');
          sessionStorage.setItem(`plumelle-scroll-teaser-shown-${widgetId}`, 'true');
        }
      },
      { capture: true }
    );
  };

  const showScrollTeaser = () => {
    const found = getTeaser();
    if (!found) return;

    const { wrapper, teaser, widgetId } = found;
    if (!widgetId || wrapper.classList.contains('open')) return;
    if (isTeaserDismissedByUser(widgetId) || isScrollTeaserShown(widgetId)) return;

    teaser.classList.add('show');
    clearTimeout(teaserHideTimeout);
    teaserHideTimeout = setTimeout(
      () => hideScrollTeaser(teaser, widgetId),
      TEASER_DURATION_MS
    );
  };

  const onWidgetRevealed = () => {
    bindTeaserClose();
    showScrollTeaser();
  };

  const updateWhatsAppVisibility = () => {
    const isVisible = window.scrollY > SCROLL_THRESHOLD;
    document.body.classList.toggle('whatsapp-widget-visible', isVisible);

    if (isVisible && !wasWidgetVisible) {
      onWidgetRevealed();
    }

    wasWidgetVisible = isVisible;
  };

  const patchChatarminBubbleImages = () => {
    const images = document.querySelectorAll('.chatarmin-widget-wrapper .comp_logo img');
    if (!images.length) return false;

    images.forEach((img) => {
      if (img.hasAttribute('width') && img.hasAttribute('height')) return;

      const inlineHeight = parseInt(img.style.height, 10);
      const size = inlineHeight || CHATARMIN_BUBBLE_SIZE;

      img.setAttribute('width', String(size));
      img.setAttribute('height', String(size));
    });

    return true;
  };

  const watchChatarminWidget = () => {
    const onWidgetReady = () => {
      if (!document.querySelector('.chatarmin-widget-wrapper')) return false;

      patchChatarminBubbleImages();
      bindTeaserClose();

      if (document.body.classList.contains('whatsapp-widget-visible')) {
        onWidgetRevealed();
      }

      return true;
    };

    if (onWidgetReady()) return;

    const observer = new MutationObserver(() => {
      if (onWidgetReady()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const bindEtrustedReviewBadgeScroll = () => {
    document.addEventListener('click', (event) => {
      const badge = event.target.closest('[data-etrusted-review-badge]');
      if (!badge) return;

      const target = document.getElementById('etrusted-reviews');
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  /**
   * Chatarmin back-in-stock injects next to a product form. Plumelle has a second
   * form in the mobile sticky ATC; the app often attaches there (display:none on
   * desktop). Reparent the button under the main PDP buy box only — never sticky.
   */
  const getMainProductForm = () =>
    [...document.querySelectorAll('[id^="MainProduct-"] product-form, .product__info-container product-form')].find(
      (el) => !el.closest('.plumelle-sticky-atc')
    ) ||
    [...document.querySelectorAll('product-form')].find((el) => !el.closest('.plumelle-sticky-atc'));

  const getChatarminBisMount = (root = document) => {
    const belowPay = root.querySelector?.('#chatarmin-backinstock-button-below-pay') ||
      (root.id === 'chatarmin-backinstock-button-below-pay' ? root : null);
    if (belowPay) return belowPay;

    const button = root.querySelector?.('#chatarmin-backinstock-button') ||
      (root.id === 'chatarmin-backinstock-button' ? root : null);
    return button?.closest('#chatarmin-backinstock-button-below-pay') || button || null;
  };

  const isOnMainPdp = (el) =>
    el &&
    !el.closest('.plumelle-sticky-atc') &&
    Boolean(el.closest('.product__buy_buttons, .product__info-container, [id^="MainProduct-"]'));

  const stripStickyChatarminBis = (sticky, keep) => {
    if (!sticky) return;
    sticky
      .querySelectorAll(
        '#chatarmin-backinstock-button-below-pay, #chatarmin-backinstock-button'
      )
      .forEach((el) => {
        if (el === keep || keep?.contains(el)) return;
        el.remove();
      });
  };

  const reparentChatarminBackInStock = () => {
    if (!document.body.classList.contains('template-product')) return false;

    const mainForm = getMainProductForm();
    if (!mainForm) return false;

    const sticky = document.querySelector('.plumelle-sticky-atc');
    const buyButtons = mainForm.closest('.product__buy_buttons');

    // If main PDP already has a BIS control, drop sticky duplicates only.
    const mainExisting =
      (buyButtons && getChatarminBisMount(buyButtons)) ||
      [...document.querySelectorAll('#chatarmin-backinstock-button-below-pay, #chatarmin-backinstock-button')].find(
        isOnMainPdp
      );

    if (mainExisting && isOnMainPdp(mainExisting)) {
      mainExisting.classList.add('plumelle-chatarmin-bis');
      stripStickyChatarminBis(sticky, mainExisting);
      return true;
    }

    // Prefer a mount trapped in sticky; otherwise any document-level node.
    const mount =
      (sticky && getChatarminBisMount(sticky)) || getChatarminBisMount(document);

    if (!mount) return false;

    mount.classList.add('plumelle-chatarmin-bis');
    stripStickyChatarminBis(sticky, mount);

    if (buyButtons) {
      buyButtons.appendChild(mount);
    } else {
      mainForm.insertAdjacentElement('afterend', mount);
    }

    return true;
  };

  const watchChatarminBackInStock = () => {
    if (!document.body.classList.contains('template-product')) return;

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        reparentChatarminBackInStock();
      });
    };

    const mounted = reparentChatarminBackInStock();

    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), mounted ? 3000 : 12000);
  };

  updateWhatsAppVisibility();
  window.addEventListener('scroll', updateWhatsAppVisibility, { passive: true });
  watchChatarminWidget();
  watchChatarminBackInStock();
  bindEtrustedReviewBadgeScroll();
})();

(function () {
  if (!document.body.classList.contains('template-product')) return;

  const ack = (node) => {
    if (typeof window.plumelleAckInteraction === 'function') {
      window.plumelleAckInteraction(node || document.documentElement);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const host = event.target && event.target.closest && event.target.closest('rubik-swatch');
      if (host) ack(host);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (!t || !t.closest) return;
    if (t.closest('.product-parameters, .plumelle-sticky-atc__variants')) ack(t);
  });

  document.addEventListener('variant:change', () => ack(document.documentElement));

  const ready = () => {
    document.documentElement.classList.add('plumelle-rubik-media-ready');
  };

  const sub = document.querySelector('.product-section .product__media-sublist');
  if (!sub) {
    ready();
    return;
  }

  const countSlides = () => sub.querySelectorAll('.product__media-subitem, .swiper-slide').length;
  let peak = countSlides();

  if (document.querySelector('rubik-swatch')?.closest('.product-parameters') && peak > 0 && peak < 60) {
    ready();
    return;
  }

  const observer = new MutationObserver(() => {
    const n = countSlides();
    if (n > peak) peak = n;
    if (peak >= 8 && n > 0 && n < peak * 0.85) {
      ready();
      observer.disconnect();
    }
  });
  observer.observe(sub, { childList: true, subtree: true });
  window.setTimeout(() => {
    ready();
    observer.disconnect();
  }, 4500);
})();